import { Helpers } from "../jobs-flow/Helpers";

export default{
    init(){
        this.verifyingDNSRecords();
        this.copyingValueButton();
    },
    verifyingDNSRecords(){
        $('.verify-dns-records').click((e) => {
            const button = $(e.currentTarget);
            button.attr('disabled', 'disabled');
            $('.status-messages-container .status-checking').removeClass('d-none');
            $.ajax({
                type: 'POST',
                url: '/admin/cockpit-settings/validate-authenticated-domain',
                data: ({}),
                success: (response) => {
                    //window.location.href = '/admin/cockpit-settings/last-step';
                    this.sendVerificationEmail(button);
                    $('.error-message').html('');
                    $('.step-checker.dns-step').addClass('complete');
                    $('.step-checker.confirmation-step').addClass('active');
                },
                error: function (response) {
                    $('.error-message').html('CNAME records may take a few hours to be updated. <br />\
                    Please double check if DNS records have been updated properly then try again in a few hours.');
                },
                complete: function (response) {
                    button.removeAttr('disabled');
                    $('.status-messages-container').find('.status-error').remove();
                    $('.status-messages-container .status-checking').addClass('d-none');
                    let validation_flag = true;
                    $.each(response.responseJSON, function (index, value) {
                        if (value.valid) {
                            validation_flag
                        } else {
                            validation_flag = false;
                            if (value.reason) {
                                $('.status-messages-container').find('.status-danger').removeClass('d-none');
                                $('.status-messages-container').append('<div class="status-row status-error">' +
                                                                        '<img src="/images/attention-circle.svg">' +
                                                                        '<div class="text-error">Verification Failed:'+ value.reason +'</div></div>');
                                $('.error_' + index).html('verification failed');
                                $('.error_' + index).addClass('text-danger');
                            }
                        }
                    });
                    /* if (validation_flag) {
                        $('.step-checker.dns-step').addClass('complete');
                    } */
                },
            });
        });
    },
    sendVerificationEmail(div) {
        $.ajax({
            type: 'POST',
            url: '/admin/cockpit-settings/send-verification-email',
            data: ({}),
            success: (response) => {
                this.verify();
            },
            error: function (response) {
                setTimeout(() => {
                    $(div).prop('disabled', false);
                    $('.waiting-danger').removeClass('d-none');
                    $('.waiting-danger').addClass('d-flex');
                    $(div).text('Verify');
                }, 1000 * 5 * 60);
            },
        });
    },
    verify() {
        $.ajax({
            type: 'POST',
            url: '/admin/cockpit-settings/verify-mx',
            data: ({}),
            success: function (response) {
                window.location.href = '/cockpit';
            },
            error: () => {
                setTimeout(() => {
                    this.verify();
                }, 15 * 1000);
            }
        });
    },

    copyingValueButton(){
        $('.copy-value').click(function() {
            const parent = $(this).parent();
            Helpers.selectElementContents(parent[0].firstChild);
        });
    },

}
